import { OETrans } from '@components/translation/OETrans';
import { ArrowRight, ConfirmSolid, RejectSolid } from '@icons';
import { updateProfile } from '@lib/api';
import { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

export default function UserNameSection({ profileFromApi }) {
	const [profile, setProfile] = useState(profileFromApi);
	const [isLoading, setIsLoading] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isDirty, setIsDirty] = useState(false);
	const [isSaved, setIsSaved] = useState(false);
	const [isError, setIsError] = useState(false);
	const [fieldsError, setFieldsError] = useState({});

	const validation = (fields) => {
		const newErrors = { ...fieldsError };
		fields.forEach((field) => {
			if (!profile[field] || profile[field].trim() === '') {
				newErrors[field] = true;
			}
		});
		setFieldsError(newErrors);
		return newErrors;
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setProfile({
			...profile,
			[name]: value,
		});

		// Remove error if field is not empty
		if (fieldsError[name] && value.trim()) {
			const newErrors = { ...fieldsError };
			delete newErrors[name];
			setFieldsError(newErrors);
		}
	};

	const handleSaveProfile = () => {
		// resetShowAlert();
		const fields = ['firstName', 'lastName'];
		const newErrors = validation(fields);
		if (Object.keys(newErrors).length === 0) {
			setIsLoading(true);
			updateProfile(profile)
				.then((response) => {
					if (response.success) {
						setIsSaved(true);
					} else {
						setIsError(true);
					}
					setIsLoading(false);
				})
				.catch((error) => {
					setIsError(true);
					setIsLoading(false);
				});
		}
	};

	return (
		<>
			<h2
				style={{
					textTransform: 'none',
					fontSize: '32px',
					fontWeight: 700,
					margin: '36.8px 0 56px 0',
					lineHeight: '100%',
				}}
			>
				Profilo
			</h2>

			<div className={`simple-box scenarita custom-simple_box`}>
				{!isEditing ? (
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<div style={{ display: 'grid', gap: '8px' }}>
							<h3
								style={{
									fontSize: '18px',
									fontWeight: 700,
									lineHeight: '28px',
									marginBottom: 0,
								}}
							>
								Nome e Cognome
							</h3>

							<p
								style={{
									lineHeight: '28px',
									marginBottom: 0,
								}}
							>
								{profile.firstName} {profile.lastName}
							</p>
						</div>
						<Button
							onClick={() => {
								setIsEditing(true);
							}}
							style={{
								border: 'none',
								backgroundColor: 'transparent',
								// color: '#06797F',
								color: 'var(--np-primary-color)',
								fontWeight: 500,
								textTransform: 'none',
							}}
						>
							Modifica
							<ArrowRight style={{ marginLeft: '12px', fill: 'var(--np-primary-color)' }} />
						</Button>
					</div>
				) : (
					<Form
						autoComplete="off"
						onSubmit={(event) => {
							event.preventDefault();
							handleSaveProfile();
						}}
					>
						<Row style={{ margin: '8px 0' }}>
							<Form.Group as={Col} sm={3}>
								<Form.Label style={{ fontWeight: 700, lineHeight: '28px' }} htmlFor="firstName">
									<OETrans code="profile.firstName" fallback={'Nome'} />
									&nbsp;<span className="required-field">*</span>
								</Form.Label>
								<Form.Control
									style={{ height: '40px' }}
									type="text"
									name="firstName"
									id="firstName"
									{...(isLoading && { disabled: true })}
									value={profile.firstName || ''}
									{...(fieldsError.firstName && { isInvalid: true })}
									onChange={(e) => {
										if (!isDirty) {
											setIsDirty(true);
										}
										handleChange(e);
									}}
								/>
								<Form.Control.Feedback type="invalid">
									<OETrans code="profile.firstNameRequired" fallback={'Il nome è obbligatorio.'} />
								</Form.Control.Feedback>
							</Form.Group>

							<Form.Group as={Col} sm={3}>
								<Form.Label style={{ fontWeight: 700, lineHeight: '28px' }} htmlFor="lastName">
									<OETrans code="profile.lastName" fallback={'Cognome'} />
									&nbsp;<span className="required-field">*</span>
								</Form.Label>
								<Form.Control
									style={{ height: '40px' }}
									type="text"
									name="lastName"
									id="lastName"
									{...(isLoading && { disabled: true })}
									value={profile.lastName || ''}
									{...(fieldsError.lastName && { isInvalid: true })}
									onChange={(e) => {
										if (!isDirty) {
											setIsDirty(true);
										}
										handleChange(e);
									}}
								/>
								<Form.Control.Feedback type="invalid">
									<OETrans code="profile.lastNameRequired" fallback={'Il cognome è obbligatorio.'} />
								</Form.Control.Feedback>
							</Form.Group>

							<Col sm={3} style={{ display: 'flex', gap: '16px', marginLeft: 'auto', marginTop: '32px' }}>
								<Button
									type="button"
									className="btn custom-outline-button"
									style={{
										width: '200px',
										height: '48px',
									}}
									onClick={() => {
										setIsEditing(false);
									}}
								>
									Annulla
								</Button>
								<Button
									type="submit"
									disabled={!isDirty || isLoading || isSaved}
									className="btn custom-primary-button"
									style={{
										width: '200px',
										height: '48px',
									}}
								>
									Conferma
								</Button>
							</Col>
						</Row>
					</Form>
				)}
				<Modal
					show={isSaved}
					onHide={() => {
						setIsSaved(false);
						setIsEditing(false);
					}}
					centered
				>
					<Modal.Header
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							gap: '16px',
						}}
					>
						<ConfirmSolid style={{ margin: '8px' }} />
						<h3
							style={{
								fontSize: '24px',
								textAlign: 'center',
								lineHeight: '35px',
								marginBottom: 0,
								fontWeight: 700,
							}}
						>
							Perfetto!
						</h3>
					</Modal.Header>
					<Modal.Body
						style={{
							padding: '0 16px',
						}}
					>
						<p
							style={{
								textAlign: 'center',
								marginBottom: 0,
								lineHeight: '28px',
							}}
						>
							Nome e cognome modificati correttamente.
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button
							className="btn custom-primary-button"
							style={{
								width: '100%',
								height: '48px',
							}}
							onClick={() => {
								setIsSaved(false);
								setIsEditing(false);
							}}
						>
							Chiudi
						</Button>
					</Modal.Footer>
				</Modal>
				<Modal
					show={isError}
					onHide={() => {
						setIsError(false);
					}}
					centered
				>
					<Modal.Header
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							gap: '16px',
						}}
					>
						<RejectSolid style={{ margin: '8px' }} />
						<h3
							style={{
								fontSize: '24px',
								textAlign: 'center',
								lineHeight: '35px',
								marginBottom: 0,
								fontWeight: 700,
							}}
						>
							Qualcosa è andato storto!
						</h3>
					</Modal.Header>
					<Modal.Body
						style={{
							padding: '0 16px',
						}}
					>
						<p
							style={{
								textAlign: 'center',
								marginBottom: 0,
								lineHeight: '28px',
							}}
						>
							Non è stato possibile modificare il nome e il cognome.
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button
							className="btn custom-outline-button"
							style={{
								width: '100%',
								height: '48px',
							}}
							onClick={() => {
								setIsError(false);
							}}
						>
							Chiudi
						</Button>
						<p style={{ width: '100%', textAlign: 'center', margin: '1rem 0' }}>Oppure</p>
						<Button
							onClick={() => {
								setIsError(false);
								handleSaveProfile();
							}}
							className="btn custom-primary-button"
							style={{
								width: '100%',
								height: '48px',
							}}
						>
							Riprova
						</Button>
					</Modal.Footer>
				</Modal>
			</div>
		</>
	);
}
